import base64 from 'base-64'
import Cookies from 'js-cookie'

// import jwt from 'jsonwebtoken'

const TOKEN = 'token'
const EXPIRES_ON = 'expires_on'
const FIRSTNAME = 'firstName'
const LASTNAME = 'lastName'
const EMAIL = 'email'
const IS_ADMIN = 'isAdmin'
const MEETINGROOMID = 'meetingRoomId'
const MEETINGROOMID_HEADER = 'meetingRoomId_header'
const MEETINGROOMID_FOOTER = 'meetingRoomId_FOOTER'

function getCookie(key) {
    const value = Cookies.get(key)
    let setValue = ''
    if (typeof value === 'string') {
        setValue = base64.decode(value)
    }
    return setValue
}

function setCookie(key, value, expires) {
    let valueToString = ''
    if (value) {
        valueToString = String(value)
    }
    let setValue = ''
    if (typeof valueToString === 'string') {
        setValue = base64.encode(valueToString)
    }

    if (expires) {
        Cookies.set(key, setValue, { expires: expires })
    } else {
        Cookies.set(key, setValue)
    }
}

function removeCookie(key) {
    Cookies.remove(key)
}

export function setToken(props) {
    clearToken()
    const { token, expires_on, firstName, lastName, email, isAdmin } = props
    setCookie(TOKEN, token)
    if (typeof token !== "undefined") setCookie(TOKEN, token)
    if (typeof expires_on !== "undefined") setCookie(EXPIRES_ON, expires_on)
    if (typeof firstName !== "undefined") setCookie(FIRSTNAME, firstName)
    if (typeof lastName !== "undefined") setCookie(LASTNAME, lastName)
    if (typeof email !== "undefined") setCookie(EMAIL, email)
    if (typeof isAdmin !== "undefined") setCookie(IS_ADMIN, isAdmin)
}

export function setMeetingRoomId(meetingRoomId) {
    removeCookie(MEETINGROOMID)
    if (typeof meetingRoomId !== "undefined") setCookie(MEETINGROOMID, meetingRoomId, 365)
}

export function setMeetingRoomIdHeader(meetingRoomId) {
    removeCookie(MEETINGROOMID)
    if (typeof meetingRoomId !== "undefined") setCookie(MEETINGROOMID_HEADER, meetingRoomId, 365)
}

export function setMeetingRoomIdFooter(meetingRoomId) {
    removeCookie(MEETINGROOMID)
    if (typeof meetingRoomId !== "undefined") setCookie(MEETINGROOMID_FOOTER, meetingRoomId, 365)
}

export function clearToken() {
    removeCookie(TOKEN)
    removeCookie(EXPIRES_ON)
    removeCookie(FIRSTNAME)
    removeCookie(LASTNAME)
    removeCookie(EMAIL)
    removeCookie(IS_ADMIN)
}

export function getAllToken() {
    if (!getCookie(TOKEN)) return {}
    return {
        [TOKEN]: getCookie(TOKEN),
        [EXPIRES_ON]: getCookie(EXPIRES_ON),
        [FIRSTNAME]: getCookie(FIRSTNAME),
        [LASTNAME]: getCookie(LASTNAME),
        [EMAIL]: getCookie(EMAIL),
        [IS_ADMIN]: getCookie(IS_ADMIN),
    }
}

export function getToken() {
    return getCookie(TOKEN)
}

export function getMeetingRoomId() {
    return getCookie(MEETINGROOMID)
}

export function getMeetingRoomIdHeader() {
    return getCookie(MEETINGROOMID_HEADER)
}

export function getMeetingRoomIdFooter() {
    return getCookie(MEETINGROOMID_FOOTER)
}





// WEBPACK FOOTER //
// ./src/display/lib/auth.js